import { computed } from "vue";
import html_default from "./template.default.html?raw"
const app_theme = import.meta.env.VITE_APP_THEME
let html = ""
if ("default" == app_theme){
    html = html_default
}
interface IProps {
  isVisible: boolean;
}
export default {
    template: html,
    props: {
      isVisible: Boolean
    },
    setup(props: IProps) {

      const spinnerIsVisible = computed(function(){
        return props.isVisible;
      })

      return {
        spinnerIsVisible,
      
      };
    }
}